/**
 * SignedContractViewerModal
 * Renderiza inline el PDF de un contrato firmado usando un iframe
 * y la URL pre-firmada de S3. Fallback: abrir en pestaña nueva.
 */

import { ExternalLink, Loader2 } from 'lucide-react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  url: string | null;
  isLoading: boolean;
}

export function SignedContractViewerModal({ isOpen, onClose, title, url, isLoading }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || 'Contrato firmado'} size="xl">
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-end gap-2 border-b border-border bg-muted/40 px-4 py-2">
          <Button
            size="sm"
            variant="secondary"
            disabled={!url}
            onClick={() => url && window.open(url, '_blank', 'noopener,noreferrer')}
          >
            <ExternalLink size={14} />
            Abrir en pestaña
          </Button>
        </div>
        <div className="relative flex-1 bg-muted/20">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center text-sm text-muted-foreground">
              <Loader2 className="mr-2 animate-spin" size={16} />
              Cargando contrato...
            </div>
          )}
          {url && (
            <iframe
              key={url}
              src={url}
              title={title || 'Contrato firmado'}
              className="h-full w-full border-0"
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
